const YOUTUBE_REGEX = /^.*((m\.)?youtu\.be\/|vi?\/|u\/\w\/|embed\/|\?vi?=|\&vi?=)([^#\&\?]*).*/;
const YT_IMAGE_URL = 'https://i.ytimg.com';
const YT_HQ_FORMAT = 'hqdefault';

function getYouTubeID(uri) {
  const [, , , videoId] = uri.match(YOUTUBE_REGEX) || [];
  return videoId;
}

function booleanToNumber(flag) {
  return flag ? 1 : 0;
}

const getPosterUrl = ({ imageData, playlistCoverId, playlist, encodedId, imageSize, webp }) => {
  if (imageData && imageData.url) return imageData.url;
  const videoPlaylisCovertId =
    typeof playlistCoverId === 'string' ? encodeURIComponent(playlistCoverId) : null;

  const format = webp ? 'webp' : 'jpg';
  const vi = webp ? 'vi_webp' : 'vi';
  return !playlist
    ? `${YT_IMAGE_URL}/${vi}/${encodedId}/${imageSize}.${format}`
    : `${YT_IMAGE_URL}/${vi}/${videoPlaylisCovertId}/${imageSize}.${format}`;
};

export { getYouTubeID, booleanToNumber, getPosterUrl, YT_IMAGE_URL, YT_HQ_FORMAT };
